module.exports = __webpack_public_path__ + "static/1-e87aaa972498fd86c52f9fb86be45c82.jpg";